import React from 'react';

const ToggleSwitch = ({ label, isChecked, onToggle, disabled = false, title = '' }) => (
  <div className="flex items-center justify-between w-full py-1" title={title}>
    <span className="text-[13px]" style={{ color: 'var(--text-secondary)' }}>{label}</span>
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={disabled}
      onClick={onToggle}
      className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
        isChecked ? 'bg-indigo-500' : ''
      } ${disabled ? 'opacity-40 cursor-not-allowed' : ''}`}
      style={!isChecked ? { backgroundColor: 'var(--border-primary)' } : {}}
    >
      <span
        aria-hidden="true"
        className={`pointer-events-none inline-block h-4 w-4 transform rounded-full shadow-sm ring-0 transition duration-200 ease-in-out ${
          isChecked ? 'translate-x-4' : 'translate-x-0'
        }`}
        style={{ backgroundColor: '#f4f4f5' }}
      />
    </button>
  </div>
);

export default ToggleSwitch;